var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.28 841.89",
    style: {
      enableBackground: "new 0 0 595.28 841.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 217.5719,
    cy: 419.3482,
    r: 347.3161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8B1DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A29CCC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.21,396.92c-7.96,0.83-14.47,5.25-17.88,12.11c-2.16,4.33-3.17,10.08-2.58,14.86 c0.79,6.47,3.06,11.32,7.17,15.21c4.33,4.11,9.68,6.1,16.33,6.1c4.7,0,9.11-1.11,12.63-3.19c2.45-1.46,6.01-5.03,7.39-7.41 c3.13-5.4,4.26-11.39,3.34-17.57c-1.66-11.41-9.44-18.97-20.65-20.13C208.49,396.65,207.72,396.65,205.21,396.92z M211.86,402.88 c6.99,1.25,11.95,6.29,13.44,13.66c0.31,1.44,0.35,2.56,0.26,5.25c-0.13,4.04-0.44,5.38-1.95,8.52c-0.94,1.97-1.33,2.51-2.97,4.15 c-1.05,1.05-2.54,2.25-3.32,2.71c-5.09,2.95-13.05,2.95-18.14,0c-2.12-1.22-4.94-4.15-6.05-6.29c-1.55-2.97-2.08-5.14-2.19-9.07 c-0.13-4.28,0.31-6.75,1.75-9.73c2.51-5.16,6.4-8.17,11.85-9.18C206.54,402.53,209.82,402.51,211.86,402.88z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 217.5719,
    cy: 419.3482,
    r: 347.3161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8B1DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A29CCC"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M492.15,396.98c-1.6,0.72-1.66,0.85-10.91,22.71c-9.79,23.08-9.49,22.18-8.2,23.65 c1.16,1.33,3.1,1.44,4.46,0.26c0.37-0.33,1.31-2.29,2.84-5.94l2.27-5.46l11.45-0.07l11.45-0.04l2.03,4.85 c1.11,2.69,2.21,5.25,2.43,5.68c1.03,2.01,3.61,2.4,5.11,0.83c0.57-0.59,0.66-0.85,0.66-1.92c-0.02-1.14-0.76-2.99-8.79-21.9 c-6.19-14.58-8.98-20.89-9.49-21.51c-0.39-0.46-1.03-0.98-1.42-1.14C495.15,396.59,493,396.61,492.15,396.98z M498.84,416 l4.26,10.29l-4.41,0.07c-2.45,0.02-6.49,0.02-9,0l-4.59-0.07l4.31-10.38c2.38-5.7,4.39-10.58,4.48-10.82 C494.1,404.54,493.64,403.49,498.84,416z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 217.5719,
    cy: 419.3482,
    r: 347.3161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8B1DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A29CCC"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.4,397.18c-0.42,0.15-0.96,0.55-1.2,0.87c-0.44,0.59-0.46,0.94-0.57,8.09c-0.07,4.11-0.11,13.86-0.11,21.68 c0,15.85-0.07,15.19,1.51,15.93c0.96,0.46,1.6,0.44,2.47-0.04c0.39-0.2,5.4-4.5,11.12-9.55c5.75-5.05,10.67-9.35,10.95-9.57 l0.5-0.39l4.63,4.11c2.56,2.27,7.41,6.58,10.77,9.55c3.37,2.99,6.43,5.62,6.78,5.84c1.29,0.81,3.06,0.35,3.74-0.94 c0.44-0.83,0.31-2.19-0.28-2.84c-0.22-0.26-3.43-3.17-7.17-6.49c-13.35-11.85-14.34-12.74-14.27-12.92 c0.04-0.09,4.9-4.39,10.82-9.59c10.8-9.49,11.21-9.9,11.21-11.26c0-0.76-0.83-1.88-1.66-2.23c-1.22-0.5-2.23-0.11-4.31,1.75 c-0.98,0.87-5.97,5.25-11.06,9.7l-9.24,8.13l-1.68-1.49c-0.92-0.81-4.76-4.24-8.55-7.58c-3.78-3.37-7.91-7.04-9.18-8.15 c-2.03-1.84-3.61-2.88-4.26-2.86C82.25,396.92,81.82,397.03,81.4,397.18z M89.71,409.68c2.45,2.16,6.21,5.51,8.37,7.43l3.91,3.48 l-0.66,0.57c-0.37,0.31-4.15,3.63-8.44,7.37c-4.26,3.76-7.82,6.84-7.89,6.84s-0.13-6.69-0.13-14.88c0-8.85,0.09-14.84,0.2-14.8 C85.18,405.7,87.28,407.52,89.71,409.68z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 217.5719,
    cy: 419.3482,
    r: 347.3161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8B1DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A29CCC"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M414.04,397.18c-0.42,0.15-0.96,0.55-1.2,0.87c-0.44,0.59-0.46,0.96-0.57,7.76 c-0.07,3.93-0.15,13.57-0.17,21.42c-0.04,13.55-0.02,14.34,0.37,15.21c0.66,1.49,2.27,2.05,3.67,1.27c0.39-0.2,5.4-4.5,11.12-9.55 c5.75-5.05,10.67-9.35,10.95-9.57l0.5-0.39l4.63,4.11c2.56,2.27,7.41,6.58,10.77,9.55c3.37,2.99,6.43,5.62,6.78,5.84 c1.29,0.81,3.06,0.35,3.74-0.94c0.44-0.83,0.31-2.19-0.28-2.84c-0.35-0.42-3.54-3.26-17.72-15.87c-2.08-1.86-3.76-3.43-3.72-3.54 c0.04-0.09,1.4-1.33,3.02-2.75c1.62-1.42,5.03-4.39,7.54-6.62c2.54-2.21,6.03-5.31,7.8-6.86c2.6-2.27,3.28-2.99,3.48-3.65 c0.44-1.49-0.28-2.86-1.75-3.3c-0.7-0.2-0.96-0.17-1.73,0.15c-0.5,0.24-5.59,4.57-11.74,9.99L438.67,417l-1.68-1.49 c-0.92-0.81-4.76-4.24-8.55-7.58c-3.78-3.37-7.91-7.02-9.18-8.15c-2.03-1.84-3.61-2.88-4.26-2.86 C414.89,396.92,414.46,397.03,414.04,397.18z M420.42,407.98c1.46,1.29,3.61,3.19,4.74,4.22c1.16,1.03,3.76,3.32,5.77,5.14 l3.69,3.26l-0.66,0.57c-0.37,0.31-4.15,3.63-8.44,7.37c-4.26,3.76-7.82,6.84-7.89,6.84c-0.07,0-0.13-6.69-0.13-14.86 c0-8.17,0.07-14.86,0.13-14.86C417.71,405.64,418.96,406.69,420.42,407.98z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 217.5719,
    cy: 419.3482,
    r: 347.3161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8B1DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A29CCC"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M244.73,397.53c-1.11,0.5-2.16,1.77-2.47,2.99c-0.33,1.25-0.33,40.94-0.02,42.07 c0.28,1.03,1.16,1.88,2.21,2.19c1.11,0.35,2.6-0.2,3.3-1.18l0.5-0.7l0.11-19.41l0.11-19.41l7.3,18.1 c4.02,9.94,7.63,18.8,8.02,19.65c0.81,1.73,1.68,2.49,3.34,2.93c1.77,0.46,3.93-0.39,4.92-1.92c0.28-0.44,3.93-9.31,8.13-19.69 l7.63-18.88l0.11,19.25c0.11,19.01,0.11,19.25,0.57,19.84c1.18,1.6,3.02,1.99,4.46,0.96c1.38-0.98,1.31,0.07,1.31-22.73 c0-23.08,0.09-21.62-1.49-23.23c-0.98-1.01-1.79-1.25-4.2-1.25c-2.19,0-3.26,0.42-4.28,1.57c-0.5,0.57-2.62,5.64-8.39,20.04 l-7.71,19.3l-7.74-19.32c-8.28-20.61-8.13-20.3-10.01-21.18C249.21,396.96,245.97,396.96,244.73,397.53z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 217.5719,
    cy: 419.3482,
    r: 347.3161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8B1DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A29CCC"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M323.97,397.35c-0.76,0.31-1.7,1.25-2.19,2.16c-0.22,0.42-4.26,9.86-8.98,20.98 c-7.82,18.45-8.59,20.33-8.59,21.46c-0.02,1.03,0.07,1.33,0.52,1.81c1.62,1.77,4.15,1.42,5.22-0.72c0.22-0.46,1.31-2.99,2.43-5.68 l2.03-4.85l11.45,0.04l11.45,0.07l2.27,5.42c1.22,2.97,2.38,5.57,2.54,5.77c0.37,0.44,1.9,1.14,2.47,1.16 c0.74,0,2.21-0.83,2.6-1.51c0.81-1.38,0.85-1.22-8.5-23.34c-9.29-21.94-9.31-22.01-10.95-22.71 C326.95,397.07,324.78,397.05,323.97,397.35z M330.42,416.06l4.41,10.67l-4.44,0.07c-2.43,0.02-6.49,0.02-8.98,0l-4.57-0.07 l4.48-10.77c2.45-5.9,4.5-10.71,4.55-10.67C325.94,405.33,327.97,410.18,330.42,416.06z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 217.5719,
    cy: 419.3482,
    r: 347.3161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8B1DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A29CCC"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M396.32,397.27c-0.52,0.2-1.33,1.01-1.66,1.64c-0.26,0.5-0.31,4.07-0.31,22.14c0,15.54,0.07,21.68,0.24,22.03 c1.09,2.1,3.67,2.45,5.2,0.7l0.68-0.79v-21.86c0-23.95,0.09-22.47-1.25-23.45C398.65,397.27,396.93,397,396.32,397.27z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 217.5719,
    cy: 419.3482,
    r: 347.3161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8B1DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A29CCC"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M141.61,397.55c-1.03,0.31-1.84,1.25-2.08,2.45c-0.28,1.31-0.31,40.89-0.04,42.36 c0.15,0.68,0.42,1.18,0.96,1.68c1.09,0.98,2.08,1.11,3.37,0.48c1.84-0.92,1.81-0.81,1.81-10.21v-8.13h7.39c4.09,0,8,0.11,8.79,0.24 c2.16,0.35,3.78,1.16,5.07,2.58c2.14,2.34,3.02,5.42,3.02,10.69c0,2.95,0.22,3.82,1.18,4.57c1.51,1.2,3.93,0.63,4.72-1.07 c1.09-2.38,0.13-10.43-1.73-14.45c-1.07-2.36-3.04-4.31-5-4.94c-0.5-0.17-0.92-0.37-0.9-0.44c0-0.07,0.68-0.46,1.51-0.85 c2.88-1.38,5.2-4.09,6.25-7.37c1.16-3.58,0.59-8.13-1.38-11.04c-2.64-3.93-6.95-6.01-13.53-6.56 C157.85,397.29,142.49,397.29,141.61,397.55z M163.1,403.76c3.32,0.7,5.46,2.14,6.56,4.48c0.5,1.07,0.57,1.51,0.57,3.41 c0,1.95-0.07,2.32-0.61,3.41c-0.72,1.49-2.08,2.78-3.8,3.67c-2.67,1.33-3.13,1.4-12.02,1.49l-8.15,0.11v-8.59v-8.57l7.93,0.13 C159.4,403.39,161.89,403.52,163.1,403.76z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 217.5719,
    cy: 419.3482,
    r: 347.3161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8B1DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A29CCC"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M349.68,397.55c-1.14,0.35-2.1,1.64-2.1,2.86c0,0.79,0.7,1.97,1.4,2.4c0.63,0.39,1.22,0.42,7.96,0.42h7.26 v19.56c0,21.48-0.07,20.54,1.31,21.53c1.44,1.03,3.28,0.63,4.46-0.96c0.46-0.59,0.46-0.79,0.52-20.35l0.04-19.76l7.45-0.07 l7.45-0.07l0.74-0.81c0.61-0.68,0.74-0.98,0.74-1.81c0-1.27-0.46-2.19-1.38-2.67c-0.66-0.37-1.92-0.39-17.97-0.44 C358.09,397.38,350.03,397.44,349.68,397.55z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.753ed429.svg";
export { ForwardRef as ReactComponent };